import { PAYMENT_SOURCE } from '../constants/constants';

export default {
  isLoading: false,
  paymentInfo: {
    source: PAYMENT_SOURCE.other,
  },
};
